import { createBrowserRouter } from 'react-router-dom'

import { PageWrapper } from '@/components/layout/PageWrapper'
import About from '@/pages/About'
import CancellationPolicy from '@/pages/CancellationPolicy'
import PropertyRules from '@/pages/PropertyRules'
import Contact from '@/pages/Contact'
import Restaurant from '@/pages/Restaurant'
import LeaveReview from '@/pages/LeaveReview'
import AdminReviews from '@/pages/AdminReviews'
import Gallery from '@/pages/Gallery'
import Home from '@/pages/Home'
import Inquire from '@/pages/Inquire'
import Treehouses from '@/pages/Treehouses'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <PageWrapper />,
    children: [
      { index: true, element: <Home /> },
      { path: 'treehouses', element: <Treehouses /> },
      { path: 'treehouses/:slug', element: <Treehouses /> },
      { path: 'gallery', element: <Gallery /> },
      { path: 'about', element: <About /> },
      { path: 'contact', element: <Contact /> },
      { path: 'inquire', element: <Inquire /> },
      { path: 'restaurant', element: <Restaurant /> },
      { path: 'leave-review', element: <LeaveReview /> },
      { path: 'admin/reviews', element: <AdminReviews /> },
      { path: 'property-rules', element: <PropertyRules /> },
      { path: 'cancellation-policy', element: <CancellationPolicy /> },
    ],
  },
])
